export const formatCRC = (value) =>
  new Intl.NumberFormat("es-CR", {
    style: "currency",
    currency: "CRC",
    maximumFractionDigits: 2
  }).format(Number(value) || 0);

export const formatDate = (value, { withTime = false } = {}) => {
  if (!value) return "N/A";

  const date = value instanceof Date ? value : new Date(String(value).replace(" ", "T"));
  if (Number.isNaN(date.getTime())) return String(value);

  return new Intl.DateTimeFormat("es-CR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: withTime ? "2-digit" : undefined,
    minute: withTime ? "2-digit" : undefined
  }).format(date);
};

export const formatDateInputValue = (date) => date.toISOString().slice(0, 10);
